export default "__VITE_ASSET__Dr5J0vuj__"